var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expand-transition',[_c('v-banner',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],attrs:{"single-line":"","color":"#1f243c"}},[_c('div',{staticClass:"d-flex tp-text-subtitle-semibold-white justify-center align-center font-weight-medium"},[_vm._v(" "+_vm._s(_vm.$t('kovo11'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }